import React from 'react'

import { QA } from '@hozana/tests/constants'

import { Ellipsis, TEllipsisProps } from 'elements/text/Ellipsis'

import { useUser } from 'modules/user/hooks/useUser'

export type TUserNameProps = {
  userId: number
} & TEllipsisProps

export const UserName: TFCC<TUserNameProps> = ({ userId, children, bold = true, ...otherProps }) => (
  <Ellipsis bold={bold} {...otherProps} data-testid={QA.USER_COMMON.NAME} vAlign="text-bottom">
    {children}
    {useUser({ userId })?.name}
  </Ellipsis>
)
